// *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** ***
// *** *** DO NOT MODIFY. THIS IS A GENERATED FILE...KITTENS COULD DIE     *** ***
// *** *** You can generate this file by running 'yarn script make.colors'  *** ***
// *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** *** ***
export default {
  BATTLESHIPGREY: '#6c7373',
  BLUEGREEN: '#2b8679',
  BLUEGREY: '#8d9494',
  CHARCOALGREY: '#394242',
  CHEETAHTEAL: '#008582',
  CRIMSON: '#bf3966',
  DARKCHARTREUSE: '#ced100',
  DUCKEGG_BLUE: '#d4d9d9',
  FADEDRED: '#e02d42',
  GREENYBLUE: '#37b8b5',
  GUNMETAL: '#505959',
  ICE: '#e8ebeb',
  JADEGREEN: '#157841',
  LIGHTCYAN: '#b2ebea',
  LIGHTGREY_BLUE: '#b2b8b8',
  LIGHTTEAL: '#2b8679',
  MAGENTA: '#f078c8',
  MINT: '#96d9d8',
  OLIVE: '#83A343',
  PALEBLUE: '#d8f2ee',
  PARCHMENT: '#f4f5ba',
  SALMON: '#fa776e',
  SEAFOAMBLUE: '#3ec0ad',
  STEELBLUE: '#5aaacc',
  TIFFANYBLUE: '#77d3c6',
  UGLYYELLOW: '#e0e200',
  VIRIDIAN: '#1b8748',
  WATERMELON: '#ee2f19',
  WHITE: '#ffffff',
  YELLOWISH: '#e9eb75',
  HUNTER: '#268E99',
  ANNOYINGORANGE: '#eb8e1b',
  EVERGREEN: '#1C4D4A',
  POPPY: '#f36f60',
  LIME: '#20b965',
  MARIGOLD: '#eeb82b',
  CANVASCOLOR: '#f7f7f7',
  ADVANCEDCOLOR: '#bf3966',
  BASICCOLOR: '#83A343',
  DISABLEDCOLOR: '#b2b8b8',
  DISABLEDBORDERCOLOR: '#f7f7f7',
  DISABLEDBACKGROUNDCOLOR: '#f7f7f7',
  DISABLEDCOLORINVERTED: '#b2b8b8',
  DISABLEDBORDERCOLORINVERTED: '#e8ebeb',
  DISABLEDBACKGROUNDCOLORINVERTED: '#e8ebeb',
  DISABLEDICONCOLOR: '#8d9494',
  SUPERCOLOR: '#e0e200',
  INFOCOLOR: '#77d3c6',
  WARNINGCOLOR: '#eb8e1b',
  ERRORCOLOR: '#ee2f19',
  ACTIONCOLOR: '#157841',
  BASECOLOR: '#394242',
  BASECOLORINVERTED: '#e8ebeb',
  MARINE200: '#afe8fa',
  MARINE300: '#8bd8f0',
  MARINE400: '#60c6e6',
  LIGHTACCENT: '#77d3c6',
  LIGHTACCENTHOVER: '#3ec0ad',
  DARKACCENT: '#77d3c6',
  DARKACCENTHOVER: '#3ec0ad',
  DARK0: '#ffffff',
  GRAY1: '#e5eff4',
  GRAY1_1: '#d4d9d9',
  GRAY1_2: '#d4d9d9',
  GRAY2: '#b8c6cc',
  BLUE2: '#6c87a1',
  BLUE5: '#007596',
  BLUE6: '#3ba7cc',
  BLUE7: '#bcc8d4',
  BLUE8: '#3c8fb2',
  BLUE9: '#a5b6c5',
  BLUE10: '#3e7c9b',
  BLUE11: '#8095a9',
  BLUE12: '#3a6682',
  BLUE13: '#70859a',
  BLUE14: '#345168',
  BLUE15: '#5f758a',
  BLUE16: '#2b3d4e',
  BLUE17: '#4f667b',
  BLUE18: '#242f3a',
  BLUE19: '#364b5f',
  BLUE25: '#1a2129',
  ACCENTINVERTED: '#77d3c6',
  ACCENTINVERTEDHOVER: '#3ec0ad',
  ACCENT: '#77d3c6',
  ACCENTHOVER: '#3ec0ad',
  ACTIONHOVER: '#20b965',
  ERRORHOVER: '#f36f60',
  WARNINGHOVER: '#eeb82b',
  ACCENTACTIVE: '#2b8679',
  ACCENTINVERTEDACTIVE: '#3ec0ad'
};
//# sourceMappingURL=colors.variables.js.map